export default __webpack_public_path__ + "static/media/ES.3bb14e2a.svg";